


































































































































































































































































































































import Vue from "vue"
import { Component } from "vue-property-decorator"
import NiPage from "@nielsen-media/nlsn-vue-ui/lib/components/NiPage.vue"
import { CatOrganization, OrgAppId, OrgClientId, OrgUser } from "@/store/modules/organizations/organizations"
import { ROUTES } from "@/constants"

@Component({
  components: { NiPage },
  filters: {
    formatDate(value: string) {
      if (!value) return ""
      return new Date(value).toLocaleString()
    },
  },
})
export default class OrganizationDetail extends Vue {
  activeTab = 0
  editDialog = false
  editAppDialog = false
  deleteAppDialog = false
  deleteClientDialog = false
  deleteOrgDialog = false
  addAppDialog = false
  addClientDialog = false
  newAppId = ""
  newClientId = ""
  appSearch = ""
  clientSearch = ""
  userSearch = ""
  editOrg = { name: "" }
  editApp = { id: "", appId: "", status: "active" }
  appToDelete = { id: "", appId: "" }
  clientToDelete = { id: "", clientId: "" }
  appStatusOptions = ["active", "inactive"]

  appHeaders = [
    { text: "App ID", value: "appId", sortable: true },
    { text: "Status", value: "status", sortable: true },
    { text: "Created At", value: "createdAt", sortable: true },
    { text: "Updated At", value: "updatedAt", sortable: true },
    { text: "Actions", value: "actions", sortable: false, align: "center" },
  ]

  clientHeaders = [
    { text: "Client ID", value: "clientId", sortable: true },
    { text: "Created At", value: "createdAt", sortable: true },
    { text: "Updated At", value: "updatedAt", sortable: true },
    { text: "Actions", value: "actions", sortable: false, align: "center" },
  ]

  userHeaders = [
    { text: "Name", value: "name", sortable: true },
    { text: "Email", value: "email", sortable: true },
    { text: "Created At", value: "createdAt", sortable: true },
  ]

  get orgId(): string {
    return this.$route.params.id
  }

  get org(): CatOrganization | null {
    return this.$store.getters["organizations/selectedOrganization"]
  }

  get loading(): boolean {
    return this.$store.getters["organizations/loading"]
  }

  get loadingAppIds(): boolean {
    return this.$store.getters["organizations/loadingAppIds"]
  }

  get loadingClientIds(): boolean {
    return this.$store.getters["organizations/loadingClientIds"]
  }

  get loadingUsers(): boolean {
    return this.$store.getters["organizations/loadingUsers"]
  }

  get orgAppIds(): OrgAppId[] {
    return this.$store.getters["organizations/orgAppIds"]
  }

  get filteredAppIds(): OrgAppId[] {
    if (!this.appSearch) return this.orgAppIds
    const q = this.appSearch.toLowerCase()
    return this.orgAppIds.filter(a =>
      a.appId.toLowerCase().includes(q) ||
      a.status.toLowerCase().includes(q)
    )
  }

  get orgClientIds(): OrgClientId[] {
    return this.$store.getters["organizations/orgClientIds"]
  }

  get filteredClientIds(): OrgClientId[] {
    if (!this.clientSearch) return this.orgClientIds
    const q = this.clientSearch.toLowerCase()
    return this.orgClientIds.filter(c =>
      c.clientId.toLowerCase().includes(q)
    )
  }

  get orgUsers(): OrgUser[] {
    return this.$store.getters["organizations/orgUsers"]
  }

  get filteredUsers(): OrgUser[] {
    if (!this.userSearch) return this.orgUsers
    const q = this.userSearch.toLowerCase()
    return this.orgUsers.filter(u =>
      u.name.toLowerCase().includes(q) ||
      u.email.toLowerCase().includes(q)
    )
  }

  get pageTitle(): string {
    return this.org ? `${this.org.name}` : "Organization Detail"
  }

  created(): void {
    this.$store.dispatch("organizations/loadOrganization", this.orgId)
    this.$store.dispatch("organizations/loadOrgAppIds", this.orgId)
    this.$store.dispatch("organizations/loadOrgClientIds", this.orgId)
    this.$store.dispatch("organizations/loadOrgUsers", this.orgId)
  }

  goBack(): void {
    this.clearOrgData()
    this.$router.push({ name: ROUTES.MANAGE_ORGANIZATIONS.name })
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text)
  }

  confirmDeleteOrg(): void {
    this.deleteOrgDialog = true
  }

  async deleteOrganization(): Promise<void> {
    await this.$store.dispatch("organizations/deleteOrganization", this.orgId)
    this.deleteOrgDialog = false
    this.clearOrgData()
    this.$router.push({ name: ROUTES.MANAGE_ORGANIZATIONS.name })
  }

  beforeDestroy(): void {
    this.clearOrgData()
  }

  clearOrgData(): void {
    this.$store.commit("organizations/setSelectedOrganization", null)
    this.$store.commit("organizations/setOrgAppIds", [])
    this.$store.commit("organizations/setOrgClientIds", [])
    this.$store.commit("organizations/setOrgUsers", [])
  }

  openEditDialog(): void {
    if (this.org) {
      this.editOrg = { name: this.org.name }
    }
    this.editDialog = true
  }

  async saveEdit(): Promise<void> {
    await this.$store.dispatch("organizations/updateOrganization", {
      id: this.orgId,
      name: this.editOrg.name,
    })
    this.$store.dispatch("organizations/loadOrganization", this.orgId)
    this.editDialog = false
  }

  openAddAppDialog(): void {
    this.newAppId = ""
    this.addAppDialog = true
  }

  async addApplication(): Promise<void> {
    const appId = this.newAppId.trim()
    if (!appId) return
    await this.$store.dispatch("organizations/createCatOrgApplication", {
      catOrganizationId: this.orgId,
      appId,
    })
    this.newAppId = ""
    this.addAppDialog = false
  }

  openEditAppDialog(item: OrgAppId): void {
    this.editApp = { id: item.id, appId: item.appId, status: item.status }
    this.editAppDialog = true
  }

  async saveAppEdit(): Promise<void> {
    await this.$store.dispatch("organizations/updateCatOrgApplication", {
      id: this.editApp.id,
      catOrganizationId: this.orgId,
      appId: this.editApp.appId,
      status: this.editApp.status,
    })
    this.editAppDialog = false
  }

  confirmDeleteApp(item: OrgAppId): void {
    this.appToDelete = { id: item.id, appId: item.appId }
    this.deleteAppDialog = true
  }

  async deleteApplication(): Promise<void> {
    await this.$store.dispatch("organizations/deleteCatOrgApplication", {
      id: this.appToDelete.id,
      catOrganizationId: this.orgId,
    })
    this.deleteAppDialog = false
  }

  openAddClientDialog(): void {
    this.newClientId = ""
    this.addClientDialog = true
  }

  async addClient(): Promise<void> {
    const clientId = this.newClientId.trim()
    if (!clientId) return
    await this.$store.dispatch("organizations/createCatOrgClient", {
      catOrganizationId: this.orgId,
      clientId,
    })
    this.newClientId = ""
    this.addClientDialog = false
  }

  confirmDeleteClient(item: OrgClientId): void {
    this.clientToDelete = { id: item.id, clientId: item.clientId }
    this.deleteClientDialog = true
  }

  async deleteClient(): Promise<void> {
    await this.$store.dispatch("organizations/deleteCatOrgClient", {
      id: this.clientToDelete.id,
      catOrganizationId: this.orgId,
    })
    this.deleteClientDialog = false
  }
}
